import React from 'react';
import { 
  FaHeartbeat, 
  FaThermometerHalf, 
  FaSyringe, 
  FaStethoscope,
  FaWeight,
  FaAppleAlt,
  FaUserMd,
  FaClipboardList
} from 'react-icons/fa';

export interface Service {
  slug: string;
  icon: React.ReactElement;
  title: string;
  description: string;
  longDescription: string;
}

const icons = {
  heart: <FaHeartbeat />,
  thermo: <FaThermometerHalf />,
  syringe: <FaSyringe />,
  stethoscope: <FaStethoscope />,
  weight: <FaWeight />,
  apple: <FaAppleAlt />,
  userMd: <FaUserMd />,
  clipboard: <FaClipboardList />
};

export const services: Service[] = [
  {
    slug: 'control-climaterio',
    icon: icons.heart,
    title: 'Control Climaterio',
    description: 'Acompañamiento integral durante el período de transición hormonal, con enfoque en el bienestar físico y emocional.',
    longDescription: 'El climaterio es una etapa natural en la vida de la mujer que requiere un acompañamiento médico especializado. Ofrezco un manejo integral y personalizado para aliviar síntomas, prevenir complicaciones y mejorar la calidad de vida durante esta transición, enfocándome en el bienestar físico y emocional.'
  },
  {
    slug: 'control-hipotiroidismo',
    icon: icons.thermo,
    title: 'Control Hipotiroidismo',
    description: 'Manejo personalizado del hipotiroidismo con seguimiento de niveles hormonales y ajuste de tratamiento.',
    longDescription: 'Realizo un manejo y seguimiento continuo del hipotiroidismo, ajustando el tratamiento según tus necesidades específicas. Mi enfoque se basa en análisis hormonales periódicos y en tu bienestar general para garantizar un equilibrio óptimo.'
  },
  {
    slug: 'control-diabetes-mellitus-2',
    icon: icons.syringe,
    title: 'Control Diabetes Mellitus 2',
    description: 'Tratamiento integral de la diabetes tipo 2 con educación del paciente y control metabólico continuo.',
    longDescription: 'Ofrezco un tratamiento integral para la Diabetes Mellitus tipo 2, que incluye educación sobre el estilo de vida, control metabólico riguroso y ajuste de medicación. El objetivo es empoderar al paciente para un manejo efectivo de su condición.'
  },
  {
    slug: 'control-hipertension-arterial',
    icon: icons.stethoscope,
    title: 'Control Hipertensión Arterial',
    description: 'Manejo de la presión arterial con enfoque preventivo y seguimiento personalizado del tratamiento.',
    longDescription: 'El control de la hipertensión arterial es clave para prevenir enfermedades cardiovasculares. Brindo un seguimiento personalizado, ajustando el tratamiento y promoviendo hábitos de vida saludables para mantener tu presión arterial en niveles óptimos.'
  },
  {
    slug: 'control-dislipidemia',
    icon: icons.weight,
    title: 'Control Dislipidemia',
    description: 'Tratamiento de alteraciones en los lípidos sanguíneos con enfoque en la prevención cardiovascular.',
    longDescription: 'La dislipidemia (colesterol y triglicéridos altos) es un factor de riesgo cardiovascular importante. Mi enfoque se centra en el tratamiento de estas alteraciones a través de cambios en el estilo de vida y medicación, si es necesario, para proteger tu salud.'
  },
  {
    slug: 'control-obesidad',
    icon: icons.apple,
    title: 'Control Obesidad',
    description: 'Programa integral de manejo del peso con enfoque en hábitos saludables y bienestar general.',
    longDescription: 'El sobrepeso y la obesidad son condiciones complejas. Ofrezco un programa de manejo de peso integral y compasivo, enfocado en la adopción de hábitos saludables y sostenibles para alcanzar un bienestar general y duradero.'
  },
  {
    slug: 'control-resistencia-a-la-insulina',
    icon: icons.userMd,
    title: 'Control Resistencia a la Insulina',
    description: 'Manejo especializado de la resistencia a la insulina con estrategias personalizadas de tratamiento.',
    longDescription: 'La resistencia a la insulina es una condición precursora de la diabetes tipo 2. Implemento estrategias personalizadas de tratamiento, dieta y ejercicio para mejorar la sensibilidad a la insulina y prevenir la progresión de la enfermedad.'
  },
  {
    slug: 'consulta-morbilidad',
    icon: icons.clipboard,
    title: 'Consulta Morbilidad',
    description: 'Atención médica general para diversas condiciones de salud con enfoque integral y preventivo.',
    longDescription: 'Atiendo una amplia gama de condiciones de salud agudas y crónicas. Mi enfoque en la consulta de morbilidad es integral y preventivo, buscando no solo tratar la enfermedad actual sino también fortalecer tu salud a largo plazo.'
  }
];